import React from "react";

function MainDisplay(props) {
  return <main className="main-display">{props.children}</main>;
}

export default MainDisplay;
